<template>
<div id="scene-container" ref="sceneContainer">
    <div id="ui-container" ref="uiContainer">
        <ArtifactDetails ref="artifact" v-bind:iden="itemId" @button="displayModal" />
        <Gate3dMetadata ref="gateMeta" v-bind:gateName="this.$router.currentRoute.name" />
    </div>
</div>
</template>

<script>
import * as THREE from 'three'
import {
    GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader'
/*import Stats from 'stats.js'*/
import GateElements from "@/components/GateElements";
import ArtifactDetails from "@/components/ArtifactDetails";
import Gate3dMetadata from "@/components/Gate3dMetadata";
import {
    AudioLoader
} from "three/src/loaders/AudioLoader";
import {
    AudioListener
} from "three/src/audio/AudioListener";
import {
    Audio
} from "three/src/audio/Audio";
import {
    bus
} from "@/main";
import {
    Quaternion
} from "three";

export default {
    name: 'Blue',
    components: {
        ArtifactDetails,
        Gate3dMetadata
    },
    data() {
        return {
            /*stats: null,*/
            container: null,
            scene: null,
            camera: null,
            startedInteraction: false,
            controls: null,
            renderer: null,
            listener: null,
            ambience: [],
            ambiencePath: [
                '/audio/gates/Blue/Blue_Atmos.mp3',
                '/audio/gates/Blue/Blue_MusicalLayer.mp3',
            ],
            audioContexts: [],
            biquadFilters: [],
            modalVisible: false,
            itemId: null,
            sceneObjects: [{
                bottles: {
                    object: null,
                    id: 0,
                },
                bolt_cutters: {
                    object: null,
                    id: 1,
                },
                car: {
                    object: null,
                    id: 2
                },
                diary: {
                    object: null,
                    id: 3
                },
                letters: {
                    object: null,
                    id: 4
                },
                newspapers: {
                    object: null,
                    id: 5,
                },
                phone_box: {
                    object: null,
                    id: 6,
                },
                record_player: {
                    object: null,
                    id: 7,
                },
                sofa: {
                    object: null,
                    id: 8
                },
                tipi: {
                    object: null,
                    id: 9,
                },
                campfire_blue: {
                    object: null,
                    id: 10,
                },
                autumn_moon: {
                    object: null,
                    id: 11,
                },
                songsheet_peace: {
                    object: null,
                    id: 12,
                },
                food_can: {
                    object: null,
                    id: 13,
                },
                letters_friends: {
                    object: null,
                    id: 14,
                },
            }],
            lastTouchPos: null,
            clock: null,
            targetRotation: null,
        }
    },
    methods: {
        async init() {
            //console.clear()

            // set container
            this.container = this.$refs.sceneContainer

            // add stats
            /*
            this.stats = new Stats()
            this.container.appendChild(this.stats.dom)
            */

            // clock needed for rotation slerp
            this.clock = new THREE.Clock()


            // add camera
            this.camera = GateElements.createFirstPersonCamera()

            // create scene
            this.scene = new THREE.Scene()
            this.scene.background = new THREE.Color('#0E1F38')

            // add lights
            const ambientLight = new THREE.HemisphereLight(
                0xffffff, // bright sky color
                0x222222, // dim ground color
                .001 // intensity
            )
            const mainLight = new THREE.DirectionalLight(0xffffff, 0.01)
            mainLight.position.set(10, 10, 10)
            this.scene.add(ambientLight, mainLight)

            // add controls
            this.controls = GateElements.createFirstPersonControls(this.camera, this.container);

            // create renderer
            this.renderer = GateElements.createRenderer()
            this.container.appendChild(this.renderer.domElement)

            // set the mouse & raycaster
            this.mouse = new THREE.Vector2()
            this.raycaster = new THREE.Raycaster();

            // load and add an object to the scene
            var sceneObject = await this.loadGeometryAsync()
            this.scene.add(sceneObject.scene)

            this.assignObjects()

            //audio part
            this.listener = new AudioListener()
            this.camera.add(this.listener)

            await this.loadPlayAmbienceAsync(this.ambiencePath[0])
            await this.loadPlayAmbienceAsync(this.ambiencePath[1])
            this.prepareFilters(0, 22000)
            this.prepareFilters(1, 22000)

        },
        fadeAudioFilter(audioFilter, audioContext, endValue) {
          audioFilter.frequency.linearRampToValueAtTime(endValue, audioContext.currentTime+2)

        },



        render() {
            this.renderer.render(this.scene, this.camera)
            /*this.stats.update()*/
        },

        animate() {
            this.renderer.setAnimationLoop(() => {
                this.render()
                if (!this.startedInteraction) this.camera.rotation.y += 0.0005
            })
            this.establishListeners()
        },


        stopAnimating() {
            this.renderer.setAnimationLoop(null);
        },

        establishListeners() {
            window.addEventListener('resize', this.onWindowResize.bind(this), false)
            window.addEventListener('click', this.onMouseClick.bind(this), false)

            window.addEventListener('touchmove', this.onTouchMove.bind(this), false);

        },

        onWindowResize() {
            // set aspect ratio to match the new browser window aspect ratio
            this.camera.aspect = window.innerWidth / window.innerHeight;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(window.innerWidth, window.innerHeight);
            this.controls.handleResize();
        },

        loadGeometryAsync() {
            return new Promise((resolve) => {
                const loader = new GLTFLoader()
                loader.load(
                    '/models/gate_blue.glb',
                    model => {
                        resolve(model)
                    },
                    undefined,
                    undefined
                )
            })
        },

        loadPlayAmbienceAsync(trackPath) {
            let tempAmbience = new Audio(this.listener)
            this.ambience.push(tempAmbience)
            return new Promise((resolve) => {
                const loader = new AudioLoader()
                loader.load(
                    trackPath,
                    buffer => {
                        tempAmbience.setBuffer(buffer)
                        tempAmbience.setLoop(true)
                        tempAmbience.setVolume(0.5)
                        tempAmbience.play()
                        resolve(buffer)
                    },
                    undefined,
                    undefined
                )
            })
        },


        prepareFilters(index, targetValue){
          this.audioContexts.push(this.ambience[index].context)
          this.biquadFilters.push(this.audioContexts[index].createBiquadFilter())
          this.biquadFilters[index].type = "lowpass"
          this.ambience[index].setFilter(this.biquadFilters[index])
          this.biquadFilters[index].frequency.setValueAtTime(targetValue, this.audioContexts[index].currentTime);
        },

        assignObjects() {
            this.sceneObjects[0].bottles.object = this.scene.getObjectByName('Bottles');
            this.sceneObjects[0].bolt_cutters.object = this.scene.getObjectByName('Bolt_Cutters');
            this.sceneObjects[0].car.object = this.scene.getObjectByName('Car')
            this.sceneObjects[0].diary.object = this.scene.getObjectByName('Diary')
            this.sceneObjects[0].letters.object = this.scene.getObjectByName('Letters');
            this.sceneObjects[0].newspapers.object = this.scene.getObjectByName('Newspapers')
            this.sceneObjects[0].phone_box.object = this.scene.getObjectByName('Phonebox')
            this.sceneObjects[0].record_player.object = this.scene.getObjectByName('Record_Player')
            this.sceneObjects[0].sofa.object = this.scene.getObjectByName('Sofa')
            this.sceneObjects[0].tipi.object = this.scene.getObjectByName('Tipi')
            this.sceneObjects[0].campfire_blue.object = this.scene.getObjectByName('Campfire_Blue')
            this.sceneObjects[0].autumn_moon.object = this.scene.getObjectByName('Autumn_Moon')
            this.sceneObjects[0].songsheet_peace.object = this.scene.getObjectByName('Songsheet_Peace')
            this.sceneObjects[0].food_can.object = this.scene.getObjectByName('Food_Can')
            this.sceneObjects[0].letters_friends.object = this.scene.getObjectByName('Letters_Friends')
        },

        onTouchMove(event) {
            const delta = this.clock.getDelta();
            const step = 3 * delta
            if (event.touches[0].clientX > this.lastTouchPos) {
                this.targetRotation = this.camera.rotation.y += 0.035
            } else {
                this.targetRotation = this.camera.rotation.y -= 0.035
            }
            if (this.camera.rotation.y !== this.targetRotation) {

                let newRot = new Quaternion(this.camera.rotation.x, this.camera.rotation.y, this.camera.rotation.z)
                this.camera.quaternion.slerp(newRot, step)
            }
            this.lastTouchPos = event.touches[0].clientX
        },

        onMouseClick(event) {

            if (!this.startedInteraction) this.startedInteraction = true

            if (this.modalVisible) return

            this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
            this.raycaster.setFromCamera(this.mouse, this.camera);
            let intersects = this.raycaster.intersectObjects(this.scene.children, true);

            if (intersects.length > 0) {
                {
                    switch (intersects[0].object) {
                        case this.sceneObjects[0].bottles.object:
                            this.itemId = this.sceneObjects[0].bottles.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].bolt_cutters.object:
                            this.itemId = this.sceneObjects[0].bolt_cutters.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].car.object:
                            this.itemId = this.sceneObjects[0].car.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].diary.object:
                            this.itemId = this.sceneObjects[0].diary.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].letters.object:
                            this.itemId = this.sceneObjects[0].letters.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].newspapers.object:
                            this.itemId = this.sceneObjects[0].newspapers.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].phone_box.object:
                            this.itemId = this.sceneObjects[0].phone_box.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].record_player.object:
                            this.itemId = this.sceneObjects[0].record_player.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].sofa.object:
                            this.itemId = this.sceneObjects[0].sofa.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].tipi.object:
                            this.itemId = this.sceneObjects[0].tipi.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].campfire_blue.object:
                            this.itemId = this.sceneObjects[0].campfire_blue.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].autumn_moon.object:
                            this.itemId = this.sceneObjects[0].autumn_moon.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].songsheet_peace.object:
                            this.itemId = this.sceneObjects[0].songsheet_peace.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].food_can.object:
                            this.itemId = this.sceneObjects[0].food_can.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].letters_friends.object:
                            this.itemId = this.sceneObjects[0].letters_friends.id
                            this.displayModal();
                            break;
                        default:
                            break;
                    }
                }
            }
        },


        displayModal() {
            this.$refs.artifact.toggleVisibility(this.itemId)
            setTimeout(this.revolveModal.bind(this), 150)


        },

        revolveModal() {
            this.modalVisible = !this.modalVisible
            if (!this.modalVisible){
              this.biquadFilters[0].frequency.setValueAtTime(22000, this.audioContexts[0].currentTime);
              this.biquadFilters[1].frequency.setValueAtTime(22000, this.audioContexts[1].currentTime);
              for (let i = 0; i < this.ambience.length; i++) {
                this.ambience[i].setVolume(1.0)
              }
            }
            else{
              this.biquadFilters[0].frequency.setValueAtTime(800, this.audioContexts[1].currentTime);
              this.biquadFilters[0].frequency.setValueAtTime(800, this.audioContexts[1].currentTime);
              for (let i = 0; i < this.ambience.length; i++) {
                this.ambience[i].setVolume(0.5)
              }
            }

        },

        disableController(valueReceived) {
            this.controls.isThreeDimensionOnly(valueReceived)
        }


    },
    computed: {
        collectables() {
            return this.$store.getters.collectables;
        }
    },
    mounted() {
        this.init().then(() => this.animate())

    },

    created() {
        bus.$on('sliderOff', this.disableController);
    },
    beforeDestroy() {
        bus.$off('sliderOff');
        this.stopAnimating()
        for (let i = 0; i < this.ambience.length; i++) {
            this.ambience[i].pause()
        }
    },
}
</script>


<style scoped>
#scene-container {
    height: 100%;
    overflow: hidden;
    z-index: 96;
}

#ui-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 97;
    /* pointer-events: auto; */
}
</style>
